import { useEffect, useState } from "react";
import { useOrderCrud } from "../context/OrderCrudContext";
import { useTheme } from "../context/ThemeContext";
import useSoftServices from "../hooks/useSoftServices";

const ServiceSelect = () => {

    const { setData } = useOrderCrud();
    const { primaryColor, colors } = useTheme();

    const [firstLoad, setFirstLoad] = useState(false);

    const [filters, setFilters] = useState({
        perPage: 200,
        currentUserServices: true,
        page: 1,
        name: ''
    });

    const [{ services, loading: servicesLoading }, getServices] = useSoftServices({ params: filters, options: { useCache: false } });

    // Función para manejar la búsqueda
    const handleSearch = (searchTerm) => {
        setFilters(prev => ({
            ...prev,
            name: searchTerm
        }));
    };

    // Función para agrupar servicios por letra inicial
    const groupServicesByLetter = (services) => {
        const grouped = {};

        services?.forEach(service => {
            if (!service?.name) return;

            const firstLetter = service.name.charAt(0).toUpperCase();

            if (!grouped[firstLetter]) {
                grouped[firstLetter] = [];
            }

            grouped[firstLetter].push(service);
        });

        // Ordenar las letras alfabéticamente
        const sortedLetters = Object.keys(grouped).sort();

        // Ordenar los servicios dentro de cada grupo alfabéticamente
        sortedLetters.forEach(letter => {
            grouped[letter].sort((a, b) => a.name.localeCompare(b.name));
        });

        return { grouped, sortedLetters };
    };

    const { grouped, sortedLetters } = groupServicesByLetter(services);

    useEffect(() => {
        if (services?.length === 1 && !firstLoad) {
            setData((oldData) => {
                return {
                    ...oldData,
                    service: services[0]
                }
            });
        }

        setFirstLoad(true);
    }, [services]);

    return (
        <div className="d-flex justify-content-center" style={{ minHeight: '60vh' }}>
            <div className="text-center w-100">
                <h3 className="mb-3 animate__animated animate__fadeIn">
                    Bienvenido
                </h3>

                {/* Input de búsqueda */}
                <div className="row justify-content-center mb-4">
                    <div className="col-md-6">
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar servicio..."
                                value={filters.name}
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {
                    servicesLoading ?
                        <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        :
                        <div className="animate__animated animate__fadeInUp w-100">
                            <h6 className="mb-4">
                                Por favor seleccione el servicio a usar
                            </h6>

                            <div className="row">
                                {sortedLetters?.length > 0 ? (
                                    sortedLetters.map(letter => (
                                        <div key={letter} className="col-12 mb-4">
                                            <div className="letter-section">
                                                <h5 className="letter-header text-primary mb-3 p-2 bg-light rounded">
                                                    {letter}
                                                </h5>
                                                <div className="row">
                                                    {grouped[letter].map((service, i) => (
                                                        <div key={service.id || i} className="col-md-3 p-2">
                                                            <div
                                                                onClick={() => setData((old) => ({ ...old, service: service }))}
                                                                className="shadow rounded p-3 service-item text-uppercase"
                                                            >
                                                                {service?.name}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12">
                                        <p className="text-muted">
                                            {filters.name ?
                                                `No se encontraron servicios para "${filters.name}"` :
                                                'No hay servicios disponibles'
                                            }
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

export default ServiceSelect;